<script lang="ts">
	import AriaText from "@components/common/AriaText.svelte";
	import type { HTMLAnchorAttributes } from "svelte/elements";
	import { isEnum } from "@core/utils/enum/isEnum.js";
	import ButtonContent from "./ButtonContent.svelte";
	import { ButtonVariant } from "./getButtonClass.js";
	import { getButtonClass } from "./getButtonClass.js";
	import { type LinkVariant, getLinkClass } from "./getLinkClass.js";

	const isButtonVariant = isEnum(ButtonVariant);
	const {
		variant,
		iconStart,
		iconEnd,
		...rest
	}: {
		variant?: ButtonVariant | LinkVariant;
		iconStart?: string;
		iconEnd?: string;
	} & Omit<HTMLAnchorAttributes, "download"> & { download?: string } = $props();

	const iconSize =
		isButtonVariant(variant) && (variant === ButtonVariant.PrimarySmall || variant === ButtonVariant.SecondarySmall)
			? "small"
			: "medium";
</script>

<a {...rest} class={[isButtonVariant(variant) ? getButtonClass(variant) : getLinkClass(variant), rest.class]}>
	<AriaText aria={rest["aria-label"] ?? ""}>
		{#if isButtonVariant(variant)}
			<ButtonContent {iconStart} {iconEnd} {iconSize}>
				{@render rest.children?.()}
			</ButtonContent>
		{:else}
			{@render rest.children?.()}
		{/if}
	</AriaText>
</a>
